// extracted by mini-css-extract-plugin
export var animationContainer = "_ol-0";
export var footer = "_ol-1";
export var gray = "_ol-2";
export var lineItem = "_ol-3";
export var lineItemImage = "_ol-4";
export var lineItemInfo = "_ol-5";
export var lineItemText = "_ol-6";
export var lineItems = "_ol-7";
export var modalContent = "_ol-8";
export var options = "_ol-9";
export var orderName = "_ol-a";
export var refundAmount = "_ol-b";